<template>
    <div>
        <el-dialog
            title="创建电表"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            append-to-body
            width="600px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                    <el-form-item label="电表号" prop="meterNumber">
                        <el-input
                            style="width: 400px;"
                            placeholder="请输入内容"
                            v-model="form.meterNumber">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="电表图片" prop="images">
                        <le-upload-file-img-ly multiple drag ref="pic" v-model="form.images" :limit='10'></le-upload-file-img-ly>
                    </el-form-item>
                </el-form>
            </div>
            
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            return {
                util,
                dialogVisible: false,
                form: {
                    meterNumber: '',
                    images: []
                },
                rules:{
                    meterNumber: [{required: true, message:'请输入电表号', trigger: 'blur'}],
                },
            };
        },
        props: {
            electricProjectId: {
                default: ''
            }
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                    this.$refs['pic'].fileList = []
                }
            },
        },
        methods:{
            handleInitUpload () {
                this.$refs['pic'].fileList = this.form.images.map(item=>{
                    return {
                        name: item.split('/')[item.split('/').length - 1],
                        url: item
                    }
                })
            },
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确认提交？','温馨提示')
                        .then(_=>{
                            this.$Axios._post({
                                url: this.$Config.apiUrl.ammeterAdd,
                                params: { 
                                    ...this.form,
                                    projectId: this.electricProjectId,
                                    meterPic: this.form.images.length ? JSON.stringify(this.form.images) : ''
                                }
                            }).then(({data}) => {
                                this.$message.success('操作成功')
                                this.$emit('success', {
                                    id: data.id,
                                    name: this.form.meterNumber,
                                    meterPic: this.form.images.length ? JSON.stringify(this.form.images) : ''
                                })
                                this.dialogVisible = false
                            })
                        })
                        .catch(_=>{})
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .content{
        background: #F2F6FC99;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        // margin: auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>